// extracted by mini-css-extract-plugin
module.exports = {"plpCardSizeSelector":"PlpCardSizeSelector_plpCardSizeSelector__HU5N2"};